import SocialIcons from "../ui/SocialIcons";

const FooterSocials = () => <SocialIcons />;

export default FooterSocials;
